// @ts-nocheck
import { createContext } from 'react';

export default createContext();